import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import ChevronDown from './Icons/ChevronDown.js';
const Select = (props) => {
    return (React.createElement("label", null,
        props.label != null ? React.createElement("span", null, props.label) : null,
        React.createElement(Wrapper, { style: props.labelStyle },
            React.createElement(SelectStyled, { ...props, style: props.style }, props.children),
            React.createElement(ChevronDown, { style: {
                    pointerEvents: 'none',
                } }))));
};
export default Select;
const Wrapper = styled.label `
  position: relative;
  margin-bottom: 20px;
  display: block;

  & > svg {
    position: absolute;
    right: 9px;
    top: 9px;
    width: 21px;
    height: 21px;
  }
`;
const SelectStyled = styled.select `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-radius: 3px;
  background-color: ${THEME.COLOR_SECONDARY};
  padding: 10px 15px;
  font-size: 0.9em;
  width: 100%;
  border: 1px solid #ccc;
  /* box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); */
  box-sizing: border-box;

  /* CAUTION: IE hackery ahead */
  &::-ms-expand {
    display: none; /* remove default arrow on ie10 and ie11 */
  }

  &:focus {
    border: 2px solid lightblue;
    padding: 9px 14px;
  }
`;
//# sourceMappingURL=Select.js.map